<template>
  <div class="DonationPrepare">
    <form id="donatie" @submit="processForm" class="mrbox round lightfill">
      <h1>Donatie</h1>
      <label class="error">{{ invalidAmount }}</label>
      <div class="controlrow edit">
        <CurrencyInput v-model="amount" />
      </div>
      <span>Wilt u een bevestiging van uw betaling? Vul dan uw mailadres in.</span>
      <label class="error">{{ invalidEmail }}</label>
      <div class="controlrow edit">
        <input type="text" placeholder="e-mailadres" v-model="email" />
      </div>
      <label class="error">{{ invalidEmailConfirmation }}</label>
      <div class="controlrow edit">
        <input type="text" placeholder="bevestig e-mailadres" v-model="emailconfirm" />
      </div>
      <div id="confirm" class="mrbox" style="height: 44px;">
        <div class="bottombar" style="text-align: left; left: 8px;">
          <button type="submit" class="button lightfill">Bevestig donatie</button>
        </div>
      </div>
    </form>

    <ModalMessage v-if="modal.show" @close="modal.show = false">
      <h1>{{ modal.title }}</h1>
      <p v-html="modal.msg"></p>
      <template #header>
        <h1>{{ modal.title }}</h1>
      </template>
      <template #body>
        <p v-html="modal.msg"></p>
      </template>
    </ModalMessage>
  </div>
</template>

<script>
import CurrencyInput from './CurrencyInput.vue';
import ModalMessage from './ModalMessage.vue';

export default {
  directives: {},
  data() {
    return {
      amount: 5.0,
      email: null,
      emailconfirm: null,
      doValidate: false,
    };
  },
  name: 'DonationPrepare',
  components: {
    ModalMessage,
    CurrencyInput,
  },
  mounted() {
    this.$store.dispatch('getMember').then(() => {
      if (this.member) {
        this.email = this.member.Email;
        this.emailconfirm = this.member.Email;
      }
    });
  },
  props: {
    msg: String,
  },
  computed: {
    modal() {
      return this.$store.state.modal;
    },
    info() {
      return this.$store.state.info;
    },
    member() {
      return this.$store.state.member;
    },
    serverMessage() {
      return this.$store.state.serverMessage;
    },
    error() {
      return this.$store.state.error;
    },
    invalidAmount() {
      return this.validateNoHtml(this.amount, 'bedrag', true);
    },
    invalidEmail() {
      return this.validateEmail(this.email, 'e-mailadres', false);
    },
    invalidEmailConfirmation() {
      return this.validateEquals(this.email, this.emailconfirm, 'bevestig e-mailadres');
    },
    action() {
      return this.$route.query.action;
    },
  },
  methods: {
    processForm(event) {
      event.preventDefault();
      this.lowerCaseAndTrimEmail();
      if (!this.validate()) {
        return;
      }

      const data = {
        Amount: this.amount,
        Email: this.email,
        Action: this.action,
      };
      this.$store.dispatch('postDonationPrepare', data); // .then(() => {});
    },
    validateNoHtml(value, label, required) {
      if (!this.doValidate) {
        return null;
      }
      if (!value && required) {
        return `${label}: verplicht`;
      }
      if (value !== '') {
        const rx = /[\^~!@#$&%*()?\][{}<>|/\\]/;
        if (rx.test(value)) {
          return `${label}: de volgende letters mogen niet worden ingevoerd: \`~!@#$%^&*()?\\/[]{}<>|\\`;
        }
        return null;
      }
      return null;
    },
    validateEmail(value, label, required) {
      if (!this.doValidate) {
        return null;
      }
      if (!value) {
        return required ? `${label}: verplicht` : null;
      }

      if (value !== '') {
        const rx = /^[\w-.]+@([\w-]+\.)+[\w-]{2,63}$/;
        if (!rx.test(value)) {
          return `${label}: Dit is geen geldig e-mailadres`;
        }
        return null;
      }
      return null;
    },
    validateEquals(value1, value2, label) {
      if (!this.doValidate) {
        return null;
      }
      if (value1 !== value2) {
        return `${label}: Invoer komt niet overeen`;
      }
      return null;
    },
    validate() {
      this.doValidate = true;
      return !(this.invalidAmount || this.invalidEmail || this.invalidEmailConfirmation);
    },
    lowerCaseAndTrimEmail() {
      if (this.email) {
        this.email = this.email.toLowerCase().trim();
      }
      if (this.emailconfirm) {
        this.emailconfirm = this.emailconfirm.toLowerCase().trim();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
